import { toast } from "react-toastify";

export default {
  serverError: (error) => {
    toast.error(error ?? "Error from the server. Please try again later!");
  },
  serverMessage: (message) => {
    if (message) {
      toast.success(message);
    }
  },
};
